import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// cart provider
import CartProvider from "./context/CartContext";
import {HelmetProvider} from 'react-helmet-async';

// Import Firebase configuration
import './firebase';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <HelmetProvider>
        <CartProvider>
            <App/>
        </CartProvider>
    </HelmetProvider>
);
